import React from "react";
import "../../assets/css/style.css";
import "./AIMachineLearning.css";
import Image from "../../assets/Image";

const iconPairs = [
  { normal: Image.webDevelopment, hover: Image.webDevelopmentHover },
  { normal: Image.appDevelopment, hover: Image.appDevelopmentHover },
  { normal: Image.paymentGateway, hover: Image.paymentGatewayHover },
  { normal: Image.websiteOptimization, hover: Image.websiteOptimizationHover },
  { normal: Image.itSolution, hover: Image.itSolutionHover },
  { normal: Image.qaTesting, hover: Image.qaTestingHover },
];

const services = [
  {
    title: "AI Strategy & Consulting",
    description:
      "Identify opportunities where Artificial Intelligence can improve business processes, increase efficiency, reduce operational costs, and drive innovation.",
  },
  {
    title: "Custom AI Application Development",
    description:
      "Design and develop intelligent AI-powered applications tailored to your unique business requirements and objectives.",
  },
  {
    title: "Machine Learning Solutions",
    description:
      "Build predictive models, recommendation systems, forecasting tools, and intelligent analytics using modern machine learning techniques.",
  },
  {
    title: "AI Chatbot Development & Integration",
    description:
      "Develop and integrate AI-powered chatbots into websites, mobile applications, customer portals, and business platforms to automate customer interactions and provide 24/7 support.",
  },
  {
    title: "AI Integration",
    description:
      "Enhance existing websites, web applications, mobile apps, and enterprise software with AI capabilities such as intelligent search, content generation, document processing, personalization, and workflow automation.",
  },
  {
    title: "Generative AI Solutions",
    description:
      "Leverage Large Language Models (LLMs) to build AI assistants, automate content creation, summarize documents, translate content, generate code, and streamline business operations.",
  },
  {
    title: "Natural Language Processing (NLP)",
    description:
      "Build solutions that understand and process human language, including text analysis, sentiment analysis, document classification, and conversational AI.",
  },
  {
    title: "Computer Vision",
    description:
      "Develop AI-powered image and video analysis solutions including object detection, OCR, facial recognition, quality inspection, and visual analytics.",
  },
  {
    title: "Predictive Analytics",
    description:
      "Transform business data into actionable insights with forecasting, trend analysis, demand prediction, and intelligent reporting.",
  },
  {
    title: "AI Automation",
    description:
      "Automate repetitive tasks and business workflows using AI to improve productivity and operational efficiency.",
  },
];

const features = [
  "AI Customer Support Chatbots",
  "AI Website Assistants",
  "Knowledge Base Chatbots",
  "FAQ Automation",
  "AI Search & Semantic Search",
  "Content Generation",
  "Email & Document Summarization",
  "Translation Services",
  "OCR & Intelligent Document Processing",
  "Voice Assistants",
  "Recommendation Systems",
  "Sentiment Analysis",
  "AI-powered Analytics & Reporting",
  "Workflow Automation",
  "AI Agents for Business Processes",
];

const technologies = [
  {
    category: "AI Platforms",
    items: [
      "Meta Llama",
      "OpenAI (ChatGPT)",
      "Cursor",
      "Google Gemini",
      "Anthropic Claude",
    ],
  },
  {
    category: "AI & Machine Learning Frameworks",
    items: ["TensorFlow", "PyTorch", "Scikit-learn", "Hugging Face", "LangChain"],
  },
  {
    category: "Computer Vision",
    items: ["OpenCV", "YOLO", "Roboflow"],
  },
  {
    category: "Development & APIs",
    items: ["Python", "FastAPI"],
  },
  {
    category: "Cloud AI Services",
    items: ["AWS AI Services", "Azure AI", "Google Vertex AI"],
  },
];

const ServiceCard = ({ title, description, iconIndex, index, total }) => {
  const icons = iconPairs[iconIndex % iconPairs.length];
  const isLastOrphan = total % 3 === 1 && index === total - 1;
  const colClass = `col-lg-4 col-md-6 col-sm-12${isLastOrphan ? " offset-lg-4" : ""}`;

  return (
    <div className={colClass}>
      <div className="what-we-provide-col">
        <div className="icon-img">
          <img className="non-hover" src={icons.normal} alt="" />
          <img className="hovericons" src={icons.hover} alt="" />
        </div>
        <h5>{title}</h5>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
};

const AIMachineLearning = () => {
  return (
    <>
      <section className="appservices-section d-flex">
        <div className="appservices-body">
          <div className="appservices-text">
            <h1>Services</h1>
            <p>
              <span>AI & Machine Learning</span>
            </p>
          </div>
        </div>
      </section>

      <section className="what-we-provide">
        <div className="container">
          <div className="title-body wow">
            <h6 className="title-clr">What We Provide</h6>
            <h2 className="all-title">Our AI & Machine Learning Services</h2>
            <p className="sub-heading">
              Empower your business with intelligent AI solutions that automate
              processes, uncover insights, and enhance customer experiences. We
              build custom AI and ML applications tailored to your business
              goals.
            </p>
          </div>
          <div className="what-we-provide-body">
            <div className="row">
              {services.map((service, idx) => (
                <ServiceCard
                  key={idx}
                  title={service.title}
                  description={service.description}
                  iconIndex={idx}
                  index={idx}
                  total={services.length}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="ai-ml-text-section">
        <div className="container">
          <div className="title-body wow">
            <h6 className="title-clr">What We Provide</h6>
            <h2 className="all-title">AI Features We Can Integrate</h2>
          </div>
          <div className="ai-ml-features-columns">
            {features.map((feature, idx) => (
              <div className="ai-ml-feature-item" key={idx}>
                <img src={Image.arrow} alt="" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ai-ml-tech-section">
        <div className="container">
          <div className="title-body wow">
            <h6 className="title-clr">What We Provide</h6>
            <h2 className="all-title">Technologies We Work With</h2>
          </div>
          <div className="ai-ml-tech-columns">
            {technologies.map((group, idx) => (
              <div className="ai-ml-tech-group" key={idx}>
                <h5>{group.category}</h5>
                <ul>
                  {group.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default AIMachineLearning;
